import { Colors } from '@/styles/colors';
import { formatDatasetLabel, getDatasetDescription } from './copy';

interface IntroPanelProps {
  algorithmName: string;
  dataset: string;
  datasetDescription: string;
  itemCount: number;
}

const infoItems = [
  'Melihat proses sorting langkah demi langkah.',
  'Membandingkan algoritma dengan jenis data yang berbeda.',
  'Membaca metrik sederhana tanpa harus menebak dari kode.',
];

export function IntroPanel({ algorithmName, dataset, datasetDescription, itemCount }: IntroPanelProps) {
  return (
    <section
      style={{
        backgroundColor: Colors.light.surface,
        border: `1px solid ${Colors.light.border}`,
        borderRadius: 8,
        padding: 'clamp(18px, 3vw, 28px)',
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.6fr) minmax(260px, 0.8fr)',
        gap: 24,
      }}
      className="intro-panel"
    >
      <div>
        <p style={{ margin: '0 0 8px', color: Colors.light.primary, fontSize: 13, fontWeight: 700 }}>
          Selamat datang di SortLab
        </p>
        <h2 style={{ margin: '0 0 12px', color: Colors.light.text, fontSize: 'clamp(24px, 4vw, 38px)', lineHeight: 1.15 }}>
          Belajar sorting dengan melihat prosesnya secara langsung.
        </h2>
        <p style={{ margin: 0, color: Colors.light.textSecondary, fontSize: 15, lineHeight: 1.7, maxWidth: 760 }}>
          SortLab adalah website interaktif untuk memahami bagaimana algoritma sorting menyusun data.
          Pilih algoritma, pilih bentuk data, lalu jalankan visualisasinya. Tujuannya sederhana:
          membantu kamu melihat perbandingan, pertukaran, dan hasil akhirnya dengan cara yang mudah diikuti.
        </p>
      </div>

      <aside
        style={{
          backgroundColor: Colors.light.background,
          border: `1px solid ${Colors.light.border}`,
          borderRadius: 8,
          padding: 16,
        }}
      >
        <div style={{ color: Colors.light.textSecondary, fontSize: 12, marginBottom: 10 }}>Sesi saat ini</div>
        <div style={{ color: Colors.light.text, fontSize: 18, fontWeight: 700, marginBottom: 6 }}>{algorithmName}</div>
        <div style={{ color: Colors.light.textSecondary, fontSize: 13, lineHeight: 1.6 }}>
          {itemCount} data - {formatDatasetLabel(dataset)}
        </div>
        <div style={{ color: Colors.light.textSecondary, fontSize: 12, lineHeight: 1.6, marginTop: 10 }}>
          {getDatasetDescription(dataset, datasetDescription)}
        </div>
      </aside>

      <div
        style={{
          gridColumn: '1 / -1',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
          gap: 10,
          borderTop: `1px solid ${Colors.light.border}`,
          paddingTop: 16,
        }}
      >
        {infoItems.map((item, index) => (
          <div key={item} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <span
              style={{
                flex: '0 0 24px',
                height: 24,
                borderRadius: 6,
                backgroundColor: Colors.light.primary + '22',
                color: Colors.light.primary,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {index + 1}
            </span>
            <span style={{ color: Colors.light.textSecondary, fontSize: 13, lineHeight: 1.5 }}>{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
